// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    all_projects_label: 'Tüm projeler',
    archive_action_text: 'Arşiv',
    Cancel: 'İptal',
    completeActivityConfirm: 'Bu aktivitenin % 100 tamamlandığını belirttiniz. Etkinliği tamamlamak istiyor musunuz ? Durumunu değiştirmek için \'OK\' veya \'İPTAL\' tuşuna basın',
    completeProjectConfirm: 'Bu projenin %100 tamamlandığınını belirttiniz. Projeyi tamamlamak istiyor musunuz ? Durumunu değiştirmek için \'OK\' tuşuna basın .',
    Edit: 'Düzenle',
    None_Text: 'Hiçbiri',
    Save: 'Kaydet',
};
